import { Link } from 'react-router-dom';
import type { Video } from '@/types/video';
import VideoListItem from '@/components/feature/VideoListItem';

interface VideoSectionProps {
  icon: string;
  title: string;
  subtitle: string;
  videos: Video[];
  moreLink: string;
  showRank?: boolean;
}

export default function VideoSection({
  icon,
  title,
  subtitle,
  videos,
  moreLink,
  showRank = false,
}: VideoSectionProps) {
  return (
    <div className="rounded-lg border border-background-800/80 bg-background-900/50 p-4 md:p-5">
      <div className="mb-4 flex items-start justify-between gap-3">
        <div className="flex items-center gap-3">
          <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-primary-500/15 text-primary-400">
            <i className={`${icon} text-xl`} />
          </span>
          <div>
            <h2 className="text-lg font-semibold text-foreground-50">{title}</h2>
            <p className="text-xs text-foreground-400">{subtitle}</p>
          </div>
        </div>
        <Link
          to={moreLink}
          className="flex items-center gap-1 whitespace-nowrap rounded-md border border-background-700 px-3 py-1.5 text-xs font-medium text-foreground-200 transition-colors hover:border-primary-500 hover:text-primary-400"
        >
          查看更多
          <i className="ri-arrow-right-s-line" />
        </Link>
      </div>
      <div className="flex flex-col gap-3">
        {videos.map((video, idx) => (
          <VideoListItem
            key={video.id}
            video={video}
            rank={showRank ? idx + 1 : undefined}
          />
        ))}
      </div>
    </div>
  );
}